import { Request } from "Utils/Request"
import { API_BASE_URL } from 'config.js';

const getUsersProfiles = (params, onSuccess, onFail) => {
    return Request({url: API_BASE_URL+'users/profiles', method: 'get', params}, onSuccess, onFail);
}

export default {
    getUsersProfiles
}